<template>
  <div>
    <v-container>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="707"
            @click:outside="closeModal"
            :retain-focus="false"
          >
            <v-card class="custom-card" rounded="0">
              <v-toolbar color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">
                  {{ titleHeading }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card
                elevation="0"
                style="padding: 20px"
                v-if="dialogCode == 'yeast-mould-count'"
              >
                <div
                  class="d-flex flex-column"
                  style="
                    width: 667px;
                    height: 88px;
                    flex-shrink: 0;
                    background: var(--neutral-5, rgba(243, 243, 243, 0.5));
                    padding: 20px;
                  "
                >
                  <span class="main-content">
                    less than 30 -
                    <span class="text--success">Acceptance</span></span
                  >
                  <span class="sub-content">
                    No environmental contamination</span
                  >
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    30 - 50 -
                    <span class="text--yellow">Satisfactory Quality</span></span
                  >
                  <span class="sub-content">
                    Chances of environmental contamination</span
                  >
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    >50 - <span class="text--danger">Affected</span></span
                  >
                  <span class="sub-content">
                    Chances of contamination with fungal spores</span
                  >
                </div>
              </v-card>

              <v-card
                elevation="0"
                style="padding: 20px"
                v-if="dialogCode == 'coliform-count'"
              >
                <div
                  class="d-flex flex-column"
                  style="
                    width: 667px;
                    height: 88px;
                    flex-shrink: 0;
                    background: var(--neutral-5, rgba(243, 243, 243, 0.5));
                    padding: 20px;
                  "
                >
                  <span class="main-content">
                    less than 50 cfu/ml -
                    <span class="text--success">Recommended</span></span
                  >
                  <span class="sub-content"> Low bacterial count</span>
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    50 - 100 - <span class="text--yellow">Medium</span></span
                  >
                  <span class="sub-content">
                    Chances of bacterial contamination</span
                  >
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    >10,000 - <span class="text--danger">High</span></span
                  >
                  <span class="sub-content"> High bacterial count</span>
                  <span class="sub-content">
                    <ul style="list-style-type: disc">
                      <li>Suggest poor milking practices</li>
                      <li>Dirty equipment</li>
                      <li>Contaminated water</li>
                    </ul></span
                  >
                </div>
              </v-card>

              <v-card
                elevation="0"
                style="padding: 20px"
                v-if="dialogCode == 'viable-count'"
              >
                <div
                  class="d-flex flex-column"
                  style="
                    width: 667px;
                    height: 88px;
                    flex-shrink: 0;
                    background: var(--neutral-5, rgba(243, 243, 243, 0.5));
                    padding: 20px;
                  "
                >
                  <span class="main-content">
                    less than 5000 -
                    <span class="text--success">Recommended</span></span
                  >
                  <span class="sub-content">
                    HIgher quality milk (Low bacterial count)</span
                  >
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    5000 - 10000 -
                    <span class="text--yellow">Medium</span></span
                  >
                  <span class="sub-content">
                    Chances of bacterial contamination</span
                  >
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    >10,000 - <span class="text--danger">High</span></span
                  >
                  <span class="sub-content">
                    High bacterial count (poor hygiene, chances if
                    mastitis)</span
                  >
                </div>
              </v-card>

              <v-card
                elevation="0"
                style="padding: 20px"
                v-if="dialogCode == 'preliminary-incubation'"
              >
                <div
                  class="d-flex flex-column"
                  style="
                    width: 667px;
                    height: 88px;
                    flex-shrink: 0;
                    background: var(--neutral-5, rgba(243, 243, 243, 0.5));
                    padding: 20px;
                  "
                >
                  <span class="main-content">
                    less than 10,000 cfu/ml -
                    <span class="text--success">Ideal</span></span
                  >
                  <span class="sub-content">
                    Regulatory standard (sanitation, cooling and milk procedures
                    are done properly).</span
                  >
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    10,000-50,000 cfu/ml -
                    <span class="text--yellow">Acceptance</span></span
                  >
                  <span class="sub-content">
                    Possibility of cow suffering from mastitis, milk
                    contamination while handling.
                  </span>
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    >50,000 cfu/ml -
                    <span class="text--danger">Concerned</span></span
                  >
                  <span class="sub-content">
                    Clinical mastitis, poor handling, poor cooling and
                    storage.</span
                  >
                </div>
              </v-card>

              <v-card
                elevation="0"
                style="padding: 20px"
                v-if="dialogCode == 'somatic-cell'"
              >
                <div
                  class="d-flex flex-column"
                  style="
                    width: 667px;
                    height: 88px;
                    flex-shrink: 0;
                    background: var(--neutral-5, rgba(243, 243, 243, 0.5));
                    padding: 20px;
                  "
                >
                  <span class="main-content">
                    >1000-99000 -
                    <span class="text--success">Normal</span></span
                  >
                  <span class="sub-content">
                    Indicated normal healthy cows.</span
                  >
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    100000-199000 -
                    <span class="text--yellow">Required Observation</span></span
                  >
                  <span class="sub-content">
                    Normal cow but required observation for mastitis for each
                    quarter (udder).
                  </span>
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    >200000-299000 -
                    <span class="text--yellow">Suspected</span></span
                  >
                  <span class="sub-content">
                    Indicates the status of cow susceptible to mastitis.</span
                  >
                </div>

                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    >300000-399000 -
                    <span class="text--danger">Affected</span></span
                  >
                  <span class="sub-content">
                    Cow affected with subclinical mastitis.</span
                  >
                </div>
                <div class="d-flex flex-column micro-flex">
                  <span class="main-content">
                    >400000 - <span class="text--danger">Suffering</span></span
                  >
                  <span class="sub-content"> Cow suffering from mastitis.</span>
                </div>
              </v-card>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
export default {
  data() {
    return {
      titles: {
        "somatic-cell": "Somatic Cell Counts",
        "preliminary-incubation": "Preliminary Incubation Counts",
        "viable-count": "Total Viable Count",
        "coliform-count": "Coliform Count",
        "yeast-mould-count": "Yeast and Mould Count",
      },
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
    titleHeading() {
      return this.titles[this.dialogCode];
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    dialogCode: {
      type: String,
      required: true,
    },
    // message1: {
    //   type: String,
    //   required: false,
    // },
    // message2: {
    //   type: String,
    //   required: false,
    // },
    // confirmBtnText: {
    //   type: String,
    //   required: false,
    // },
  },
  mixins: [loadingMixin],
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped>
::v-deep .v-text-field--enclosed .v-input__append-inner {
  margin-top: 10px;
}

::v-deep .v-input__control fieldset {
  border: none;
}
::v-deep .v-input__slot fieldset:first-child {
  border-top: 1px solid #bbb;
}
::v-deep .v-form span:last-child .v-input__slot fieldset {
  border-bottom: 1px solid #bbb;
}
::v-deep .highlightedInput {
  border: 1px solid #00bd73;
  border-width: 1px 0 1px 0;
  border-radius: 0;
}

.text--success {
  color: #198754;
}
.text--yellow {
  color: #ffc107;
}

.text--danger {
  color: #dc3545;
}

.sub-content {
  font-size: 16px;
}

.main-content {
  font-size: 18px;
  font-weight: bold;
}

.micro-flex {
  width: 667px;
  /* height: 88px; */
  flex-shrink: 0;
  background: var(--neutral-5, rgba(243, 243, 243, 0.5));
  padding: 20px;
  margin-top: 20px;
}
</style>
